import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';



@Injectable({
  providedIn: 'root',
})
export class UserContextPoolService {
 // BehaviorSubject holds the current value and emits it to new subscribers
private userPoolIdSource = new BehaviorSubject<string | null>(null);

// Expose as an observable for read-only access
userPoolId$ = this.userPoolIdSource.asObservable();

private userRegionSource = new BehaviorSubject<string | null>(null);
// Expose as an observable for read-only access
userRegion$ = this.userRegionSource.asObservable();


private amplifyConfigSource = new BehaviorSubject<string | null>(null);
// Expose as an observable for read-only access
amplifyConfig$ = this.amplifyConfigSource.asObservable();

constructor() { }

// Method to set the value (Call this from AuthService)
setUserPoolId(id: string) {
this.userPoolIdSource.next(id);
}

// Method to get the current value synchronously (useful for Interceptors)
getUserPoolId(): string | null {
return this.userPoolIdSource.getValue();
}

setUserRegion(id: string) {
this.userRegionSource.next(id);
}

// Method to get the current value synchronously (useful for Interceptors)
getUserRegion(): string | null {
return this.userRegionSource.getValue();
}

setamplifyConfig(config:string){
  this.amplifyConfigSource.next(config);
}
getamplifyConfig():string|null{
  return this.amplifyConfigSource.getValue();
}
}
